import React from 'react';
import { Box } from '@staffino/primitive-controls';
import { Choice } from '@staffino/model';
import {
  ChoiceWrapper,
  HighlightableChoiceWrapper,
} from '../components/choice-wrapper';
import ChoiceRadioButton from '../components/choice-radio-button';

type Props = React.ComponentProps<typeof Box> & {
  key?: string;
  name?: string;
  choices?: Choice[];
  otherChoice?: Choice;
  otherChoiceInput?: React.ReactNode;
  commentHighlighted?: boolean;
  colorStyle?: string;
  value?: string;
  onFocus?: () => void;
  onFocusOtherChoice?: () => void;
  onBlurOtherChoice?: () => void;
  onChange?: (value: string) => void;
};

const SingleChoiceControl: React.ForwardRefExoticComponent<
  Props & React.RefAttributes<unknown>
> = React.forwardRef(
  (
    {
      key,
      name,
      choices = [],
      otherChoice,
      otherChoiceInput,
      commentHighlighted,
      colorStyle,
      value,
      onFocus,
      onFocusOtherChoice,
      onBlurOtherChoice,
      onChange,
      ...rest
    }: Props,
    ref: React.Ref<unknown>,
  ) => {
    return (
      <Box {...rest}>
        {choices.map((choice, index) => (
          <ChoiceWrapper
            key={choice.id}
            separator={!!otherChoice || index !== choices.length - 1}
            color="text"
          >
            <ChoiceRadioButton
              key={key ?? choice.id}
              innerRef={ref}
              name={name}
              score={choice.id}
              checked={value === choice.id}
              colorStyle={colorStyle}
              isSelected={value === choice.id}
              onFocus={onFocus}
              onChange={() => onChange?.(choice.id)}
            >
              {choice.title}
            </ChoiceRadioButton>
          </ChoiceWrapper>
        ))}
        {otherChoice && (
          <HighlightableChoiceWrapper
            highlight={commentHighlighted}
            color="text"
            className={value?.includes(otherChoice.id) ? 'active' : ''}
          >
            <ChoiceRadioButton
              key={key ?? otherChoice.id}
              innerRef={ref}
              name={name}
              score={otherChoice.id}
              checked={value === otherChoice.id}
              colorStyle={colorStyle}
              isSelected={value === otherChoice.id}
              onFocus={onFocusOtherChoice}
              onBlur={onBlurOtherChoice}
              onChange={() => onChange?.(otherChoice.id)}
            />
            {otherChoiceInput}
          </HighlightableChoiceWrapper>
        )}
      </Box>
    );
  },
);

export default SingleChoiceControl;
